module.exports = __webpack_public_path__ + "img/active.7da8ac19.svg";